<script setup lang="ts">
import BaseDialog from '~/components/molecules/BaseDialog.vue'

withDefaults(
  defineProps<{
    title?: string
    message: string
    isActive: boolean
    okButton?: {
      text?: string
      color: 'primary' | 'danger'
    }
  }>(),
  {
    title: undefined,
    okButton: () => {
      return {
        color: 'primary',
      }
    },
  }
)

const emit = defineEmits<{
  ok: []
  cancel: []
}>()

const ok = () => emit('ok')
const cancel = () => emit('cancel')
</script>

<template>
  <BaseDialog
    :title="title"
    :is-active="isActive"
    :buttons="{
      ok: {
        text: okButton.text || $t('OK'),
        color: okButton.color,
      },
      cancel: { text: $t('キャンセル') },
    }"
    @close="cancel"
    @ok="ok"
    @cancel="cancel"
  >
    <template #content>
      <div>
        <div class="message-area">{{ message }}</div>
      </div>
    </template>
  </BaseDialog>
</template>

<style type="scss" scoped>
.message-area {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-wrap;
}
</style>
